import { EnglishTranslation, PortugueseTranslation, RomanianTranslation, SpanishTranslation, Translator } from "../multigame/Translator";

export class TranslationService extends Translator
{
    public constructor()
    {
        super([EnglishTranslation, SpanishTranslation, PortugueseTranslation]);
    }
}